import { forkJoin, of } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { map, mergeMap, tap } from 'rxjs/operators';
// NGRX
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
// Services
import { OrdersService } from '../_services/';
// State
import { AppState } from '../../reducers';
// Actions
import {
	OneOrderDeleted,
	OrderActionTypes,
	OrderCreated,
	OrderOnServerCreated,
	OrdersPageLoaded,
	OrdersPageRequested,
	OrdersPageToggleLoading,
	OrderUpdated
} from '../_actions/order.actions';

@Injectable()
export class OrderEffects {
	showPageLoadingDistpatcher = new OrdersPageToggleLoading({isLoading: true});
	showLoadingDistpatcher = new OrdersPageToggleLoading({isLoading: true});
	hideActionLoadingDistpatcher = new OrdersPageToggleLoading({isLoading: false});

	@Effect()
	loadOrdersPage$ = this.actions$
		.pipe(
			ofType<OrdersPageRequested>(OrderActionTypes.OrdersPageRequested),
			mergeMap(({payload}) => {
				this.store.dispatch(this.showPageLoadingDistpatcher);
				const requestToServer = this.ordersService.findOrders(payload.page);
				const lastQuery = of(payload.page);
				return forkJoin(requestToServer, lastQuery);
			}),
			map(response => {
				const result: QueryResultsModel = response[0];
				const lastQuery: QueryParamsModel = response[1];
				return new OrdersPageLoaded({
					Orders: result.items,
					totalCount: result.totalCount,
					page: lastQuery
				});
			}),
		);

	// @Effect()
	// deleteOrder$ = this.actions$
	// 	.pipe(
	// 		ofType<OneOrderDeleted>(OrderActionTypes.OneOrderDeleted),
	// 		mergeMap(({payload}) => {
	// 				this.store.dispatch(this.showLoadingDispatcher);
	// 				return this.orderEventsService.deleteOrder(payload.id);
	// 			}
	// 		),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// deleteOrders$ = this.actions$
	// 	.pipe(
	// 		ofType<ManyOrdersDeleted>(OrderActionTypes.ManyOrdersDeleted),
	// 		mergeMap(({payload}) => {
	// 				this.store.dispatch(this.showLoadingDispatcher);
	// 				return this.orderEventsService.deleteOrders(payload.ids);
	// 			}
	// 		),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// updateOrdersStatus$ = this.actions$
	// 	.pipe(
	// 		ofType<OrdersStatusUpdated>(OrderActionTypes.OrdersStatusUpdated),
	// 		mergeMap(({payload}) => {
	// 			this.store.dispatch(this.showLoadingDispatcher);
	// 			return this.orderEventsService.updateStatusForOrder(payload.Orders, payload.status);
	// 		}),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// updateOrder$ = this.actions$
	// 	.pipe(
	// 		ofType<OrderUpdated>(OrderActionTypes.OrderUpdated),
	// 		mergeMap(({payload}) => {
	// 			this.store.dispatch(this.showLoadingDispatcher);
	// 			return this.orderEventsService.updateOrder(payload.Order, payload.Order.id); // TODO: fix this
	// 		}),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// createOrder$ = this.actions$
	// 	.pipe(
	// 		ofType<OrderOnServerCreated>(OrderActionTypes.OrderOnServerCreated),
	// 		mergeMap(({payload}) => {
	// 			this.store.dispatch(this.showLoadingDispatcher);
	// 			return this.orderEventsService.createOrder(payload.Order).pipe(
	// 				tap(res => {
	// 					this.store.dispatch(new OrderCreated({Order: res}));
	// 				})
	// 			);
	// 		}),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// init$: Observable<Action> = defer(() => {
	//     const queryParams = new QueryParamsModel({});
	//     return of(new OrdersPageRequested({ page: queryParams }));
	// });

	constructor(private actions$: Actions, private ordersService: OrdersService, private store: Store<AppState>) {
	}
}
